<template>
  <div class="container">
    <div v-if="isLoading" class="row justify-content-center">
      <div class="col-12 col-md-8 text-center">
        <mainloader />
      </div>
    </div>

    <div v-else class="row realEstate">
      <div class="col-12">
        <div class="text-center">
          <errorAlert v-if="hasError" :alertMessage="message" :errorNumber='errorNumber' />
        </div>
        <div class="row">
          <div class="col-3">
            <div class="card-custom">
              <div class="d-flex justify-content-between align-items-center mb-4">
                <h6 class="title">العقارات</h6>
                <h2 class="progressNumber">{{ current }}</h2>
              </div>
              <div class="progress custom-progress">
                <div
                  class="progress-bar"
                  role="progressbar"
                  :style="{ width: progress + '%' }"
                ></div>
              </div>
              <div class="text-end mt-3 total">
                من {{ total }}
              </div>
            </div>
          </div>
          <div class="col-md-3">
            <ProgressCard
              title="المستخدمين"
              :current="8"
              :total="20"
              color="#49B27D"
            />
          </div>
          <div class="col-md-3">
            <ProgressCard
              title="إعلانات مميزة"
              :current="0"
              :total="20"
              color="#AA9359"
            />
          </div>
          <div class="col-md-3">
            <ProgressCard
              title="جلسات تصوير"
              :current="2"
              :total="20"
              color="#E05E5E"
            />
          </div>
        </div>

        <div class="row pt-3">
          <div class="col-12 col-md-7 recentActivity">
            <div class="card">
              <div class="card-body">
                <h6>{{$t('recentActivity')}}</h6>
                <div class="row pt-3">
                  <div class="col">
                    تمت إضافة عقار جديد في حي النرجس بواسطة المستخدم أحمد
                  </div>
                  <div class="col-auto duration">
                    منذ ساعتين
                  </div>
                </div>
                <hr>
                <div class="row">
                  <div class="col">
                    تم حجز جلسة تصوير للفيلا رقم 42 من قبل الإدارة
                  </div>
                  <div class="col-auto duration">
                    يوم أمس
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="col-12 col-md-5 manageCurrent_plan">
            <div class="card">
              <div class="card-body">
                <h6>{{$t('manageCurrent_plan')}}</h6>
                <p>{{$t('featuresCurrent')}}</p>
                <div class="row justify-content-center">
                  <div class="col-11 consumptionRate">
                    <div class="card">
                      <div class="card-body">
                        <div class="row">
                          <div class="col">
                            {{$t('consumptionRate')}}
                          </div>
                          <div class="col-auto">
                            %23.4
                          </div>
                        </div>
                        <div class="row pt-2">
                          <div class="col">
                            {{$t('userConsumption')}}
                          </div>
                          <div class="col-auto">
                            %23.4
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="row pt-3 justify-content-center">
                  <div class="col-12 col-md-6 btn-green" @click="paymentFN">
                    <div>{{$t('packageRenewal')}}</div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>


    <!-- begin:payment_Renew your package -->
    <button type="button"  id="selectPayment" class="btn btn-primary d-none" data-bs-toggle="modal" data-bs-target="#paymentModal">
      </button>
    <div class="modal fade" id="paymentModal" tabindex="-1" aria-labelledby="paymentModalLabel" aria-hidden="true">
      <div class="modal-dialog">
        <div class="modal-content">
          <div class="modal-body">
            <div class="row py-2">
              <div class="col almarai-bold">
                {{$t('wallet.payment')}}
              </div>
              <div class="col-auto mouse-hand" id="closeModal" data-bs-dismiss="modal" aria-label="Close">
                <i class="fa-regular fa-circle-xmark fs-5 gray-color"></i>
              </div>
            </div>

            <div class="py-2 gray-color">{{$t('wallet.choosePayment_Method')}}</div>

            <div class="row py-3">
              <label class="almarai-bold mb-2">{{$t('wallet.cost')}}</label>
              <div class="col-12">
                <div class="d-flex input-style">
                  <span class="gray-color almarai-bold">{{$t('wallet.cost')}}</span>
                  <div class="direction">
                    <span class="mx-2 gray-color almarai-bold">{{price}}</span>
                    <span>
                      <img src="/assets/images/icons/riyal.png" class="max-16" alt="">
                    </span>
                  </div>
                </div>
              </div>
            </div>

            <label class="almarai-bold pt-2">{{$t('wallet.title_13')}}</label>
            <div class="row pt-3 justify-content-center">
              <div class="col-12 position-R">
                <label for="visa" class=" mouse-hand d-block">
                  <div :class="(paymentGate == 'online')? 'wallet-style priceList' : 'wallet-style'">
                    <input class="form-check-input radio-left select_Radio" v-model="paymentGate" type="radio" value="online" name="radioDefault" id="visa">
                    <img src="/assets/images/icons/bank.png" class="width-icon" alt="">
                    <span class="mx-2 almarai-bold">{{$t('wallet.title_14')}}</span>
                    <span class="bankCard">{{$t('wallet.bankCard')}}</span>
                  </div>
                </label>
              </div>
            </div>

            <div class="row pt-3 justify-content-center">
              <div class="col-12 position-R">
                <label for="radioDefault1" class=" mouse-hand d-block">
                  <div :class="(paymentGate == 'wallet')? 'wallet-style priceList' : 'wallet-style'">
                    <input class="form-check-input radio-left select_Radio" v-model="paymentGate"  value="wallet" type="radio"  name="radioDefault" id="radioDefault1">
                    <img src="/assets/images/icons/wallet-3.png" class="width-icon" alt="">
                    <span class="mx-2 almarai-bold">{{$t('wallet.title_16')}}</span>
                    <span class="bankCard">{{$t('wallet.appWallet')}}</span>
                  </div>
                </label>
              </div>
            </div>

            <div class="row pt-3 justify-content-center">
              <loader v-if="paymentLoading" class="text-center" />
              <div v-else class="col-11 col-md-8 text-center">
                <div @click.prevent="payrenewpackage" class="form-control padding-style almarai-bold buttonStyle">{{$t('maintenanceDetails.title_5')}} </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- end:payment_Renew your package -->

    <!--begin:Charge your wallet -->
    <div class="modal bg-color-B" tabindex="-1" id="chargeWallet">
      <div class="modal-dialog">
        <div class="modal-content">
          <div class="modal-header headerWallet">
            <button type="button" class="btn-close m-0" @click="closePopupCharge" data-bs-dismiss="modal" aria-label="Close"></button>
          </div>
          <h6 class="modal-title text-center almarai-bold pt-3">{{$t('balanceInsufficient')}}</h6>
          <div class="modal-body">
            <div class="row justify-content-center">
              <div class="col text-center">
                <div class="small-Font">{{$t('chargeWallet')}}</div>
              </div>
            </div>

            <div class="row pt-3">
              <div class="col">
                <router-link to="/wallet">
                  <div class="btn-green fonttext-14">{{$t('btnChargeWallet')}}</div>
                </router-link>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!--end:Charge your wallet -->

    <!--begin:addAd_WalletBalance -->
    <button type="button"  id="addAd_WalletBalance" class="d-none" data-bs-toggle="modal" data-bs-target="#popup_WalletBalance"></button>
    <div class="modal bg-color-B" tabindex="-1" id="popup_WalletBalance">
      <div class="modal-dialog">
        <div class="modal-content">
          <div class="modal-header headerWallet">
            <button type="button" class="btn-close m-0" id="closeAdDetails" data-bs-dismiss="modal" aria-label="Close"></button>
          </div>
          <h6 class="modal-title text-center almarai-bold pt-3">{{$t('walletPaymentConfirmation')}}</h6>
          <div class="modal-body">
            <div class="row" v-if="paymentGate == 'wallet'">
              <div class="col-auto almarai-bold content-center">{{$t('walletBalance')}}</div>
              <div class="col text-start">
                {{USER_WALLET_BALANCE}}
                <span class="mx-1 green-color-F icon-saudi_riyal_bold_new"></span>
              </div>
            </div>

            <div class="row">
              <div class="col-auto almarai-bold content-center">{{$t('totalOrder')}}</div>
              <div v-if="isFeatured" class="col text-start">
                {{ featuredAdPrice }}
                <span class="mx-1 green-color-F icon-saudi_riyal_bold_new"></span>
              </div>
              <div v-else class="col text-start">
                {{ normalPrice }}
                <span class="mx-1 green-color-F icon-saudi_riyal_bold_new"></span>
              </div>
            </div>

            <div class="row" v-if="paymentGate == 'wallet'">
              <div class="col-auto almarai-bold content-center">{{$t('remainingBalance')}}</div>
              <div class="col text-start">
                {{totalPrice}}
                <span class="mx-1 green-color-F icon-saudi_riyal_bold_new"></span>
              </div>
            </div>

            <div class="row justify-content-center pt-3">
              <div v-if="min_loader" class="text-center">
                <loader />
              </div>
              <div v-else class="col-11 col-md-6 text-center" @click.prevent="advertisementCreate">
                <div class="btn-black">{{$t('confirmButton')}}</div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!--end:addAd_WalletBalance -->
  </div>
</template>
<script>
import { mapGetters } from 'vuex'
import ProgressCard from "@/components/ProgressCard.vue";

export default {
  name:"packageDetails",
  data(){
    return{
      isLoading: true,
      hasError: false,
      message: '',
      errorNumber: null,
      packageID: this.$route.query.packageID,
      userLang: 'ar',
      current: 150,
      total: 1000,
      paymentGate: "",
      price: null,
      totalPrice: null,
    }
  },
  computed: {
    ...mapGetters(['MEDIA_URL','GET_USER','USER_WALLET_BALANCE']),

    progress() {
      return (this.current / this.total) * 100;
    }
  },
  components: {
    ProgressCard,
  },
  methods: {
    getPackageDetails(){
      this.$http.get('/api/mPackages/retrieve/'+this.packageID).then(res => {
        this.price = res.data.price;
        // this.getSubscriptionDetails();
        this.activeSubscription();
        this.isLoading = false;
      }).catch(err => {
        // console.log(err);
        this.isLoading = false;
        [this.message, this.errorNumber] = this.$globalError(err, true);
        this.hasError = true;
        window.scrollTo({top:0, behavior: 'smooth'});
      })
    },

    // getSubscriptionDetails(){
    //   this.$http.get('/api/mPackages/subscription/'+this.packageID).then(res => {
    //     this.rows = res.data.rows
    //     this.isLoading = false;
    //   }).catch(err => {
    //     // console.log(err);
    //     this.isLoading = false;
    //     [this.message, this.errorNumber] = this.$globalError(err, true);
    //     this.hasError = true;
    //     window.scrollTo({top:0, behavior: 'smooth'});
    //   })
    // },

    activeSubscription(){
      this.$http.get('/api/mPackages/myActive').then(res => {
        console.log(res);
      }).catch(err => {
        this.isLoading = false;
        [this.message, this.errorNumber] = this.$globalError(err, true);
        this.hasError = true;
        window.scrollTo({top:0, behavior: 'smooth'});
      })
    },

    createSubscribe(){
      this.$http.post('/api/mPackages/subscribe',{
        paymentGate: this.paymentGate,
        packageId: this.packageID,
        latitude: this.latitude,
        longitude: this.longitude,
      }).then(res => {
        console.log();
      }).catch(err => {
        this.isLoading = false;
        [this.message, this.errorNumber] = this.$globalError(err, true);
        this.hasError = true;
        window.scrollTo({top:0, behavior: 'smooth'});
      })
    },

    payrenewpackage(){
      if(this.paymentGate == 'online'){
        this.createSubscribe();
      }else{
        this.WalletDetails();
      }
    },
    
    WalletDetails(){
      document.getElementById('closeModalDoc').click();
      if(this.price > this.USER_WALLET_BALANCE){
        document.getElementById('chargeWallet').style.display = 'block';
      }else{
        if(this.isFeatured) {
          this.totalPrice = this.USER_WALLET_BALANCE - this.price;
        }else {
          this.totalPrice = this.USER_WALLET_BALANCE - this.price;
        }
        document.getElementById('addAd_WalletBalance').click();
      }
    },

    paymentFN(){
      document.getElementById('selectPayment').click();
    },
  },
  created(){
    this.getPackageDetails();
    window.scrollTo({top:0, behavior: 'smooth'});
    this.userLang = localStorage.getItem('lang') ?? 'ar';
  }
}
</script>
<style scoped>
  .card-custom{
    border:1px solid #d9def7;
    border-radius:24px;
    padding:14px;
    background:#fff;
  }

.progressNumber{
  color:#3842B3;
  font-size:28px;
  font-weight:700;
  margin:0;
}

.title{
  color:#6f6254;
  font-weight:700;
  margin:0;
}

.custom-progress{
  height:10px;
  background:#e6e8f8;
  border-radius:20px;
  overflow:hidden;
  direction: ltr;
}

.custom-progress .progress-bar{
  background:#3842B3;
}

.total{
  color:#9c9c9c;
  /* font-size:20px; */
  font-weight:600;
}
</style>